module.exports = "/_next/static/images/d5b575dc924e8354ffc826321a6f18a3-phone-icon.svg.webp";